/* eslint-disable */
import React, { useState } from 'react'
import { Info, Code, Archive, DollarSign, List } from "react-feather"
import { useParams } from 'react-router-dom'
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap'
import useFetch from '../../../../@core/auth/apiService/useFetch'
import DetailsCode from './DetailsCode'
import DetailsGeneral from './DetailsGeneral'
import DetailsCharacteristic from './DetailsCharacteristic'
import DetailsPricesAndList from './DetailsPricesAndList'
import { configGetProdotto } from '../../../../@core/auth/apiService/configs'
import DetailsWarehouse from './DetailsWareHouse'
import NewBreadCrumbs from '../../../../@core/components/breadcrumbs/NewBreadCrumbs'



export const Details = () => {
    const params = useParams()
    const id = params.id
    const [active, setActive] = useState('1')
    const [tipoProdotto, setTipoProdotto] = useState('')


    //call al server per i prodotti

    const { data } = useFetch(configGetProdotto(JSON.stringify([{ id: Number(id) }])))
    const prodottoCaratteristiche = data.prodottoCaratteristiche
    const prodottoGenerale = data.prodottoGenerale

    const pullData = (data) => {
        setTipoProdotto(data)
    }

    const toggle = tab => {
        setActive(tab)
    }
    if (prodottoGenerale)
        return (
            <>
                <NewBreadCrumbs title={'Dettaglio'}></NewBreadCrumbs>
                <Row>
                    <Col
                        className='col-auto md'>
                        <Nav
                            className='nav-left md'
                            pills
                            vertical
                        >
                            <NavItem>
                                <NavLink
                                    active={active === '1'}
                                    onClick={() => {
                                        toggle('1')
                                    }}
                                >
                                    <Info />
                                    Generali
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    active={active === '2'}
                                    onClick={() => {
                                        toggle('2')
                                    }}
                                >
                                    <Code />
                                    Codici
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    active={active === '3'}
                                    onClick={() => {
                                        toggle('3')
                                    }}
                                >
                                    <List />
                                    Caratteristiche
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    active={active === '4'}
                                    onClick={() => {
                                        toggle('4')
                                    }}
                                >
                                    <Archive />
                                    Magazzino
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    active={active === '5'}
                                    onClick={() => {
                                        toggle('5')
                                    }}
                                >
                                    <DollarSign />
                                    Prezzi e Listini
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </Col>
                    <Col lg='10' sm='12'>
                        <TabContent activeTab={active}>
                            <TabPane tabId='1'>
                                <DetailsGeneral value={prodottoGenerale ? prodottoGenerale : 'niente'} pullData={(data) => pullData(data)} />
                            </TabPane>
                            <TabPane tabId='2'>
                                <DetailsCode value={id} newData={data.prodottoCodici ? data.prodottoCodici : []} />
                            </TabPane>
                            <TabPane tabId='3'>
                                <DetailsCharacteristic value={tipoProdotto} prodottoCaratteristiche={prodottoCaratteristiche} id={id} />
                            </TabPane>
                            <TabPane tabId='4'>
                                <DetailsWarehouse id={id}></DetailsWarehouse>
                            </TabPane>
                            <TabPane tabId='5'>
                                <DetailsPricesAndList costo={prodottoGenerale.costo} prezzo={prodottoGenerale.prezzoVendita}></DetailsPricesAndList>
                            </TabPane>
                        </TabContent>
                    </Col>
                </Row>
            </>
        )
}